/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Resource } from '@ngxp/rest';

export enum ZertifikatStatus {
  AKTIV = 'AKTIV',
  ABLAUFEND = 'ABLAUFEND',
  ABGELAUFEN = 'ABGELAUFEN',
  WIDERRUFEN = 'WIDERRUFEN',
}

export interface Zertifikat {
  name: string;
  status: ZertifikatStatus;
  validUntil: string;
  fingerprint: string;
}

export interface ZertifikatResource extends Zertifikat, Resource {}

export enum ZertifikatLinkRel {
  SELF = 'self',
  RENEW = 'renew',
  REVOKE = 'revoke',
  CERTIFICATE = 'certificate',
  CA_CERTIFICATE = 'caCertificate',
}

export interface ZertifikatDownload {
  linkRel: ZertifikatLinkRel;
  fileName: string;
}

export const ZERTIFIKAT_FILE_NAME: string = 'zertifikat.pem';
export const CA_ZERTIFIKAT_FILE_NAME: string = 'ca-zertifikat.pem';
